import {CitySlug} from "../../../../../config/cities";

const STORAGE_KEY = "charts:recent-map-region-searches";
const STORAGE_EVENT = "charts:recent-map-region-searches-updated";
const MAX_RECENT = 5;
const STORAGE_VERSION = 1;

export interface IRecentMapRegionSearch {
    regionId: number;
    slug: string;
    type: number;
    hasChartsAccess: boolean;
    label: string;
    subtitle: string | null;
    citySlug: CitySlug | null;
}

export type RecentMapRegionSearchInput = IRecentMapRegionSearch;

type StoredRecentSearches = {
    v: typeof STORAGE_VERSION;
    items: IRecentMapRegionSearch[];
};

const isClient = typeof window !== "undefined";

const parseStored = (raw: string | null): IRecentMapRegionSearch[] => {
    if (!raw) {
        return [];
    }

    try {
        const data = JSON.parse(raw) as Partial<StoredRecentSearches>;
        return data.v === STORAGE_VERSION && Array.isArray(data.items) ? data.items : [];
    } catch {
        return [];
    }
};

export const readRecentMapRegionSearches = (): IRecentMapRegionSearch[] => {
    if (!isClient) {
        return [];
    }

    return parseStored(window.localStorage.getItem(STORAGE_KEY));
};

export const writeRecentMapRegionSearches = (items: IRecentMapRegionSearch[]) => {
    if (!isClient) {
        return;
    }

    const payload: StoredRecentSearches = {v: STORAGE_VERSION, items};
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    window.dispatchEvent(new Event(STORAGE_EVENT));
};

export const upsertRecentMapRegionSearch = (
    current: IRecentMapRegionSearch[],
    entry: RecentMapRegionSearchInput
): IRecentMapRegionSearch[] => {
    const withoutDuplicate = current.filter((item) => item.regionId !== entry.regionId);

    return [entry, ...withoutDuplicate].slice(0, MAX_RECENT);
};

export const subscribeRecentMapRegionSearches = (onChange: () => void) => {
    if (!isClient) {
        return () => undefined;
    }

    window.addEventListener(STORAGE_EVENT, onChange);
    window.addEventListener("storage", onChange);

    return () => {
        window.removeEventListener(STORAGE_EVENT, onChange);
        window.removeEventListener("storage", onChange);
    };
};
